<script setup>
import { computed } from 'vue';

const props = defineProps({
    src: String,
    alt: String,
    fallback: {
        type: String,
        default: '/img/user-profile-images/user-avatar-circle-anon.svg'
    },
    position: {
        type: String,
        default: 'center center'
    },
    contain: {
        type: Boolean,
        default: false
    },
    small: {
        type: Boolean,
        default: false
    },
    large: {
        type: Boolean,
        default: false
    }
});

const backgroundImage = computed(() =>
    [props.src && `url("${props.src}")`, `url("${props.fallback}")`].filter(Boolean).join(', ')
);
</script>

<template>
    <div
        class="rounded-full bg-dust-100 bg-no-repeat border border-dust-100"
        :class="{
            'w-6 h-6': small,
            'w-8 h-8': !small && !large,
            'w-10 h-10': large,
        }"
        :style="{
            backgroundSize: contain ? 'contain' : 'cover',
            backgroundImage,
            backgroundPosition: position,
        }"
    />
</template>
